module.exports = __webpack_public_path__ + "img/MES6Indice2.0d5f5280.png";